import SEO from '@/components/feature/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const seoData = {
    title: '首页',
    description: '蘑菇成品人视频精选合集汇聚最全面的蘑菇成品人视频资源，涵盖蘑菇种植全流程、成品展示及人工操作技巧，帮助用户快速掌握蘑菇从培育到成品的完整视频教程。',
    keywords: '蘑菇成品人视频,蘑菇种植视频教程,蘑菇成品展示视频,蘑菇人工培育全流程,蘑菇成品制作视频,蘑菇种植操作视频,蘑菇成品采收视频',
    canonicalUrl: 'https://mushroom-tutorial.com/',
    schemaJson: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '蘑菇成品人视频精选合集 - 首页',
      description: '蘑菇成品人视频精选合集汇聚最全面的蘑菇成品人视频资源，涵盖蘑菇种植全流程、成品展示及人工操作技巧。',
      url: 'https://mushroom-tutorial.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '蘑菇成品人视频精选合集',
        url: 'https://mushroom-tutorial.com',
      },
    },
  };

  return (
    <>
      <SEO {...seoData} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <FeaturedVideos />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}